import { useStore, useStoreMap } from 'effector-react'
import {
  Form,
  carLicenseeModel,
} from '~/entities/common/Organizations/CarLicensee'
import { usePermissions } from '~/entities/common/viewer'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'
import { formSubmitted, $carLicensee, carLicenseeUpdateFx } from './model'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'requisites', anchor: 'requisites' },
  { labelI18n: 'registry', anchor: 'registry' },
  { labelI18n: 'contacts', anchor: 'contacts' },
]

export function EditCarLicensee() {
  const { canUpdateCarLicensees } = usePermissions()

  const isLoading = useStore(carLicenseeModel.requestFx.pending)
  const isSaving = useStore(carLicenseeUpdateFx.pending)

  const defaultValues = useStoreMap($carLicensee, (carLicensee) => ({
    ...carLicensee?.getAttributes(),
  }))

  return (
    <>
      <Form
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSuccess={formSubmitted}
        isSubmitting={isSaving}
        canEdit={canUpdateCarLicensees}
      />

      <QuickNavigation options={quickNavigationOptions} />
    </>
  )
}
